module.exports = __webpack_public_path__ + "static/media/ic-drawer-opening-hr.79c3ce64.svg";